module.exports = __webpack_public_path__ + "static/media/flickr.c1755dfc.svg";